// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import appReducer from "./appSlice/app";
import authReducer from "./authSlice/authSlice";
import verificationReducer from "./publicSlice/certificationVerification";
import registeredExamReducer from "./examSlice/examHistory";
import contactReducer from "./contactSlice/contact";
import commonReducer from "./commonSlice/common";
import certificationReducer from "./certificationSlice/certificationsHistory";
import awardsReducer from "./certificationSlice/awards";
import landingStatsReducer from "./commonSlice/landingStatSlice";
import selectedExamReducer from "./examSlice/selectedExam";
import examPaperReducer from "./examSlice/examPaper";
import userFeedbackReducer from "./examSlice/userFeedback";
import ongoingExamReducer from "./examSlice/ongoingExam";
import answerSheetSubmissionReducer from "./examSlice/submitAnswerSheet";
import leaderboardSlice from "./publicSlice/leaderboardSlice";
import userLeaderboard from "./leaderboardSlice/userLeaderboard";
import leaderboardConsent from "./leaderboardSlice/leaderboardConsent";
import extendExamReducer from "./examSlice/extendExam";

export const store = configureStore({
  reducer: {
    app: appReducer,
    auth: authReducer,
    verification: verificationReducer,
    common: commonReducer,
    registeredExams: registeredExamReducer,
    contact: contactReducer,
    certifications: certificationReducer,
    awards: awardsReducer,
    landingStats: landingStatsReducer,
    selectedExam: selectedExamReducer,
    examPaper: examPaperReducer,
    userFeedback: userFeedbackReducer,
    ongoingExam: ongoingExamReducer,
    examResults: answerSheetSubmissionReducer,
    leaderboard: leaderboardSlice,
    userLeaderboard: userLeaderboard,
    leaderboardConsent: leaderboardConsent,
    extendExam: extendExamReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
